"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAsyncIterable = void 0;
/**
 * Return true when the informed value is an async iterable, and false otherwise
 * @param value the value to be analyzed
 * @returns The return is also a type guard, ie, inside an if with that function, the value will be considered an async iterable
 */
function isAsyncIterable(value) {
    return !!(value && typeof value[Symbol.asyncIterator] === 'function');
}
exports.isAsyncIterable = isAsyncIterable;
